export default {
  draft: "Draft",
  in_progress: "In Progress",
  open: "Open",
  complete: "Complete",
  planned: "Planned",
  complete_closed: "Closed",
  closed: "Closed",
  unknown: "Unknown",
}
